import { formatDate } from '@strata/helper-functions';
import { DateInput } from '@strata/react-date-time';
import { InlineMessage } from '@strata/react-inline-message';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { windowStartFromDay } from 'services/TherapyGroupPreferenceHelpers';

const previewMessage = (day) => `Showing configuration in effect on ${formatDate(day)}.`;

export const AsOfDateField = ({ day, onChange }) => {
    const viewingAnotherDay = !dayjs(day).isSame(dayjs(), 'day');

    const handleChange = (newDate) => {
        if (!newDate || dayjs(newDate).isSame(day, 'day')) {
            return;
        }
        onChange(windowStartFromDay(newDate));
    };

    return (
        <>
            <div className="sds_therapy-group__as-of-date">
                <DateInput
                    id="asOfDate"
                    name="asOfDate"
                    label="As of date"
                    value={day}
                    onChange={handleChange}
                />
            </div>
            {viewingAnotherDay && (
                <InlineMessage
                    intent={InlineMessage.Intent.INFO}
                    wrapText
                    label={previewMessage(day)}
                />
            )}
        </>
    );
};

AsOfDateField.propTypes = {
    day: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
